import React, { Component } from "react";

import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

import ImageMcDonalds_1 from "../images/realisations/projet_mcdonalds/1_MACDONALDS.jpg";
import ImageLaHaye_1 from "../images/realisations/projet_tribunal-la-haye/01_Eurojust_tribunal_dela_Haye.jpg";
import ImageMinistere_1 from "../images/realisations/projet_affaires-etrangeres/01_Ministeredesaffairesetrangeres.jpg";
import ImageBanqueMondiale_1 from "../images/realisations/projet_banque-mondiale/01-Banque-Mondiale.jpg";
import ImageMGMCasino_1 from "../images/realisations/projet_mgm-casino/01-MGM_Casino_Fish_Restaurant.jpg";

class Realisations extends Component {
  constructor(props) {
    super(props);

    this.height = window.innerHeight - 188;

    this.state = {
      selectedKey: null,
      listDisabled: false,
      sliderVisible: false
    };
  }

  handleListClick = (event, key) => {
    event.preventDefault();

    this.setState({
      selectedKey: key,
      listDisabled: true,
      sliderVisible: true
    });
  };

  render() {
    return (
      <React.Fragment>
        <section className="projects projects--margin">
          <LocalizedLink
            className="projects__item projects__item--100 projects__item--first"
            style={{ backgroundImage: `url(${ImageMcDonalds_1})` }}
            to="/realisations/mcdonalds-champs-elysees"
          >
            <div className="projects__item-title">
              Mcdonald's Champs Elysées • {this.props.t("common:LabelOpenProject")}{" "}
              <i className="f7 i-arrow-right-light" />
            </div>
          </LocalizedLink>

          <LocalizedLink
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageMGMCasino_1})` }}
            to="/realisations/mgm-casino"
          >
            <div className="projects__item-title">
              MGM Casino Fish Restaurant • {this.props.t("common:LabelOpenProject")}{" "}
              <i className="f7 i-arrow-right-light" />
            </div>
          </LocalizedLink>

          <LocalizedLink
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageMinistere_1})` }}
            to="/realisations/ministere-des-affaires-etrangeres"
          >
            <div className="projects__item-title">
              {this.props.t("realisations:ministryOfForeignAffairs")} • {this.props.t("common:LabelOpenProject")}{" "}
              <i className="f7 i-arrow-right-light" />
            </div>
          </LocalizedLink>
          <LocalizedLink
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageBanqueMondiale_1})` }}
            to="/realisations/institution-internationale"
          >
            <div className="projects__item-title">
              {this.props.t("realisations:internationalInstitution")} • {this.props.t("common:LabelOpenProject")}{" "}
              <i className="f7 i-arrow-right-light" />
            </div>
          </LocalizedLink>

          <LocalizedLink
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageLaHaye_1})` }}
            to="/realisations/eurojust-la-haye"
          >
            <div className="projects__item-title">
              Eurojust - La Haye • {this.props.t("common:LabelOpenProject")}{" "}
              <i className="f7 i-arrow-right-light" />
            </div>
          </LocalizedLink>
        </section>

        <section className="w-100 pv7">
          <div className="w-100 tc">
            <LocalizedLink className="button button--large" to="/create">
              {this.props.t("common:labelCreateYourModel")}
            </LocalizedLink>
          </div>
        </section>

        <Footer t={this.props.t} />
      </React.Fragment>
    );
  }
}

export default Realisations;



// WEBPACK FOOTER //
// ./src/components/Realisations.js